export default ".modal-body {\n  text-align: center;\n}\n\n.message {\n  width: 100%;\n  color: black;\n  overflow: hidden;\n  word-wrap: break-word;\n}"